export default "__VITE_ASSET__04c5bf18__"